import { useEffect } from "react";

const DEFAULT_TITLE = "Elektra Health";

interface UsePageTitleOptions {
  restoreOnUnmount?: boolean;
}

export const usePageTitle = (
  pageTitle: string,
  { restoreOnUnmount = false }: UsePageTitleOptions = {},
) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = pageTitle
      ? `${DEFAULT_TITLE} | ${pageTitle}`
      : DEFAULT_TITLE;

    if (!restoreOnUnmount) return;

    return () => {
      document.title = previousTitle;
    };
  }, [pageTitle, restoreOnUnmount]);
};
